import 'regenerator-runtime/runtime'
import { watchForDemographicsActions } from 'components/demographics/sagas'
import { watchForHorizontalNavigation } from 'components/horizontalNavigation/sagas'
import { watchForQuestionActions } from 'components/question/sagas'
import { all } from 'redux-saga/effects'
import { watchForDownload } from 'sagas/downloadFromFirebase/sagas'
import { watchForUpload } from 'sagas/uploadToFirebase/sagas'
import { analyticsWatcher } from 'sagas/analytics'
import { watchForRehydration } from 'sagas/rehydration'
import {
  watchForFilterChanges,
  watchForStorageOfDownloadedAnswers
} from 'components/filter/sagas'

/**
 * Root Saga
 */
export default function* rootSaga() {
  yield all([
    watchForQuestionActions(),
    watchForDemographicsActions(),
    watchForHorizontalNavigation(),
    watchForUpload(),
    watchForDownload(),
    analyticsWatcher(),
    watchForRehydration(),
    watchForFilterChanges(),
    watchForStorageOfDownloadedAnswers()
  ])
}
